import { TableUI } from "components/design/TableUI";
import { Button } from "components/DesignSystem/Button/Button";
import { TaskStatus } from "components/TaskStatus/TaskStatus";
import { useMemo } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { Task } from "types/Models/task";
import Table from "components/DesignSystem/Table/V2/Table";
import { ConditionalLink } from "components/conditionalLink";

export const IncorporationDissolutionTaskTable = ({
  taskList,
}: {
  taskList: Task[];
}) => {
  const columnHelper = createColumnHelper<Task>();

  const columns = useMemo(() => {
    return [
      columnHelper.accessor("title", {
        header: "Name",
        size: 25,
        cell: (info) => {
          return (
            <div className="t-text-subtext t-text-text-60">
              {info.getValue()}
            </div>
          );
        },
      }),

      columnHelper.accessor("display_text", {
        header: "Details",
        size: 40,
        cell: (info) => {
          return (
            <div className="t-text-body-sm t-text-text-60 t-pr-6">
              {info.getValue() || "-"}
            </div>
          );
        },
      }),

      columnHelper.accessor("status", {
        header: "Status",
        size: 20,
        cell: (info) => (
          <TaskStatus
            status={info.getValue()}
            state={info.row?.original?.state}
            statusType={info.row?.original?.state_details?.type}
          />
        ),
      }),
      columnHelper.accessor("uuid", {
        header: "",
        size: 15,
        cell: (info) => {
          return (
            <ConditionalLink to={`/tax/filings/${info.getValue()}`}>
              <span>
                <Button size="small">View Details</Button>
              </span>
            </ConditionalLink>
          );
        },
      }),
    ];
  }, []);

  const table = useReactTable({
    data: taskList,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="t-h-fit t-mb-12">
      <TableUI table={table}>
        {({ row }) => (
          <Table.Row
            key={row.original.uuid}
            className="hover:t-bg-surface-lighter-grey"
          >
            {row.getVisibleCells().map((cell) => {
              return (
                <Table.Cell
                  key={cell.id}
                  className="t-py-4 t-px-2"
                  style={{
                    width: `${cell.column.getSize()}%`,
                  }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Table.Cell>
              );
            })}
          </Table.Row>
        )}
      </TableUI>
    </div>
  );
};
